/**
*
* FullscreenError
*
*/

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { colors } from 'ui/constants';
import { calc } from 'utils/zoom';

const StyledContainer = styled.div`
  display: flex;
  height: ${calc('100vh')};
  width: ${calc('100vw')};
  justify-content: center;
  align-items: center;
  background: ${colors.lightergray};
  z-index: 5;
  position: absolute;
  top: 0;
`;

const StyledError = styled.div`
  background: #fff;
  border-radius: 4px;
  border: 2px solid ${colors.blue};
  padding: 16px;
  margin: 16px;
  z-index: 10;
`;


function FullscreenError({ children }) {
  return (
    <StyledContainer>
      <StyledError>{children}</StyledError>
    </StyledContainer>
  );
}

FullscreenError.propTypes = {
  children: PropTypes.node.isRequired,
};

export default FullscreenError;
